import { render, staticRenderFns } from "./ConfirmarDescripcion.vue?vue&type=template&id=8718ad68"
import script from "./ConfirmarDescripcion.vue?vue&type=script&lang=ts"
export * from "./ConfirmarDescripcion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports